// extracted by mini-css-extract-plugin
module.exports = {"SideInput":"SideInput_SideInput__3Obhz"};